import MaskedInput from 'react-text-mask'

const MASKS = {
  phone: [/\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/],
  zipCode: (value: string): Record<string, any> => {
    const val = value ? value.replace(/\s/g, '') : ''

    if (val.length <= 5 || val.endsWith('-')) return [/\d/, /\d/, /\d/, /\d/, /\d/]
    else return [/\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]
  },
}

export type ComponentProps = {
  inputRef: any
  maskType: string
  style?: React.CSSProperties
}

export const PhoneMaskCustom: React.FC<ComponentProps> = ({ inputRef, maskType, ...other }) => {
  return (
    <MaskedInput
      {...other}
      ref={(ref) => {
        inputRef(ref ? ref.inputElement : null)
      }}
      mask={MASKS[maskType || 'phone']}
      placeholderChar={'\u2000'}
    />
  )
}
